import { render, staticRenderFns } from "./PaymentProcessModal.vue?vue&type=template&id=22b25c4c&"
import script from "./PaymentProcessModal.vue?vue&type=script&lang=js&"
export * from "./PaymentProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports